<template>
  <tr class="servicescategory-tr"
      :data-parent="`parent-${object.parent_id}`"
      :class="{
        haschildren: object.children && object.children.length > 0,
        collapse: object.parent_id && object.parent_id != 0,
        show: groupsopened.includes(parseInt(object.parent_id))
      }">
    <td :data-title="$t('id')">
      {{ object.id }}
    </td>
    <td class="tdclickable order-mob-0" @click="show(object)">
      <div :style="`padding-left: ${(object.deep_level - 1)*30}px;`">
        <PlusSvg v-if="object.children && object.children.length > 0 && !groupsopened.includes(parseInt(object.id))" class="mr-3 d-inline-block align-middle"/>
        <MinusSvg v-if="object.children && object.children.length > 0 && groupsopened.includes(parseInt(object.id))" class="mr-3 d-inline-block align-middle"/>
        <span v-if="object.info" class="color-code" :style="`background-color: ${object.info.color}`"></span>
        <span class="d-inline-block align-middle">{{ object.title }}</span>
      </div>
    </td>
    <td :data-title="$t('parent_group')">
      {{ object.parent ? object.parent.title : '-' }}
    </td>
    <slot></slot>
  </tr>
</template>

<script>

import PlusSvg from '@/assets/svg-vue/general/boxplus.svg'
import { mapState } from "vuex"
import MinusSvg from '@/assets/svg-vue/general/boxminus.svg'

export default {
  name: "ServicesDatatableTRServiceCategory",
  components: {
    PlusSvg,
    MinusSvg
  },
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ...mapState({
      groupsopened: state => state.warehousegroup.groupsopened,
    }),
  },
  methods: {
    show(object) {
      this.$store.commit('toggleGroup', object)
    }
  }
}
</script>

<style scoped lang="scss">
.servicescategory-tr {
  &.haschildren {
    .tdclickable {
      color: $blue-color;
      cursor: pointer;
      font-weight: 600;
    }
  }
  .color-code {
    width: 16px;
    height: 16px;
    margin-right: 15px;
    border-radius: 100%;
    display: inline-block;
    vertical-align: middle;
    border: 1px solid $gray-icon;
  }
}
</style>
